import { render, staticRenderFns } from "./ProgramaRecompensaDetalhe.vue?vue&type=template&id=8f709ffc&scoped=true&"
import script from "./ProgramaRecompensaDetalhe.vue?vue&type=script&lang=js&"
export * from "./ProgramaRecompensaDetalhe.vue?vue&type=script&lang=js&"
import style0 from "./ProgramaRecompensaDetalhe.vue?vue&type=style&index=0&id=8f709ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f709ffc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDivider,VIcon})
